import {Cell, Pie, PieChart, Tooltip} from "recharts";
import {PIE_CHART_COLORS} from "../../../../utils/constants";
import React from "react";

export const BeautifulPieChart = ({
  data,
  dataKey,
  nameKey,
  width = 300,
  height = 400,
}) => (
  <PieChart
    width={width}
    height={height}
  >
    <Pie
      data={data}
      dataKey={dataKey}
      nameKey={nameKey}
      cx="50%"
      cy="50%"
      outerRadius={120}
      label
    >
      {data.map((entry, index) => (
        <Cell
          key={`cell-${index}`}
          fill={PIE_CHART_COLORS[index % PIE_CHART_COLORS.length]}
        />
      ))}
    </Pie>
    <Tooltip/>
  </PieChart>
)